exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-input[data-v-671eba0c]{max-width:300px;margin-top:20px}.wh-block__stud[data-v-671eba0c]{flex-direction:column}.wh-block__items[data-v-671eba0c]{width:100%;margin-top:20px}", ""]);

// exports
